<div class="dialog-wrapper bg-default-black p-4 pt-2 m-1 text-inverse-color">
  <div class="flex justify-items-center">
    <div class="text-xl text-center">{{ pageTitle() }}</div>
    <div class="close-button ml-auto text-xl">
      <button (click)="closeDialog()" class="">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>
  </div>

  @let topInst = topInstructions();
  @if (topInst) {
    <div class="text-center text-sm mt-3 mb-3">{{ topInst }}</div>
  }
  <kexp-steering-wheel [steeringMode]="steeringMode()" onDialog="true"
                       (pathTaken)="closeDialog()"></kexp-steering-wheel>
  @let bottomInst = bottomInstructions();
  @if (bottomInst) {
    <div class="text-center text-sm mt-2 mb-1">{{ bottomInst }}</div>
  }

</div>
